import React from "react";
import styles from "./Footer.module.css";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();

  if (pathname === "/terminos" || pathname === "/privacidad") {
    return null;
  }
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <p className={styles.text}>Medicina Total © 2025. Todos los derechos reservados.</p>

        <div className={styles.links}>
          <a href="/terminos" target="_blank" rel="noopener noreferrer">
            Términos y Condiciones
          </a>
          <span className={styles.separator}>•</span>
          <a href="/privacidad" target="_blank" rel="noopener noreferrer">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>
  );
}
